import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  NavLink,
  Navigate,
  Outlet,
  useNavigate
} from "react-router-dom";
import { useState } from "react";

import LiveUsers from "./pages/LiveUsers";
import LiveBan from "./pages/LiveBan";

import DeviceBan from "./pages/DeviceBan";
import DeviceBanList from "./pages/DeviceBanList";
import Login from "./pages/Login";
import LiveBanList from "./pages/LiveBanList";
import LiveBanHistory from "./pages/LiveBanHistory";

import AgencyManagement from './pages/AgencyManagement';
import CommissionSetting from "./pages/CommissionSetting";
import AgencyRecharge from "./pages/AgencyRecharge";
import CountryHead from "./pages/CountryHead";
import AdminList from "./pages/AdminList";
import BDAdmin from "./pages/BDAdmin";
import UserControl from "./pages/UserControl";

import HostRewardSetting from "./pages/HostRewardSetting";
import HostRights from "./pages/HostRights";
import HostRewards from "./pages/HostRewards";
import Applications from "./pages/Applications";

const ProtectedLayout = ({
  liveMenuOpen, setLiveMenuOpen,
  deviceMenuOpen, setDeviceMenuOpen,
  adminMenuOpen, setAdminMenuOpen,
  userMenuOpen, setUserMenuOpen,
  settingsMenuOpen, setSettingsMenuOpen,
  applicationMenuOpen, setApplicationMenuOpen
}) => {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();

    navigate("/login", { replace: true });
  };

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="app">
      <div className="sidebar">
        <h2>Butter Live</h2>

        <div className="menu-title">Dashboard</div>

        {/* Admin Rights Dropdown */}
        <div
          className="menu-title"
          onClick={() => setAdminMenuOpen(!adminMenuOpen)}
          style={{ cursor: "pointer" }}
        >
          Admin Rights {adminMenuOpen ? "▼" : "▶"}
        </div>

        {adminMenuOpen && (
          <div className="sub-menu">
            <NavLink
              to="/country-head"
              className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
            >
              Country Head
            </NavLink>

            <NavLink
              to="/admin-list"
              className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
            >
              Admin
            </NavLink>

            <NavLink
              to="/bd-admin"
              className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
            >
              BD Admin
            </NavLink>

            <NavLink
              to="/agency-management"
              className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
            >
              Agency
            </NavLink>

            <NavLink
              to="/agency-recharge"
              className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
            >
              Agency Recharge
            </NavLink>
          </div>
        )}

        {/* Application Management Dropdown */}
        <div
          className="menu-title"
          onClick={() => setApplicationMenuOpen(!applicationMenuOpen)}
          style={{ cursor: "pointer" }}
        >
          Application {applicationMenuOpen ? "▼" : "▶"}
        </div>

        {applicationMenuOpen && (
          <div className="sub-menu">
            <NavLink
              to="/applications"
              className={({ isActive }) =>
                isActive ? "menu-item active" : "menu-item"
              }
            >
              Applications
            </NavLink>
          </div>
        )}

        {/* User Rights*/}
<div
  className="menu-title"
  onClick={() => setUserMenuOpen(!userMenuOpen)}
  style={{ cursor: "pointer" }}
>
  User Rights {userMenuOpen ? "▼" : "▶"}
</div>

{userMenuOpen && (
  <div className="sub-menu">
    <NavLink
      to="/user-control"
      className={({ isActive }) =>
        isActive ? "menu-item active" : "menu-item"
      }
    >
      User Control
    </NavLink>

    <NavLink
      to="/host-rights"
      className={({ isActive }) =>
        isActive ? "menu-item active" : "menu-item"
      }
    >
      Host Rights
    </NavLink>

    <NavLink
      to="/host-rewards"
      className={({ isActive }) =>
        isActive ? "menu-item active" : "menu-item"
      }
    >
      Host Rewards
    </NavLink>
  </div>
)}




        {/* Live Management Dropdown */}
        <div
          className="menu-title"
          onClick={() => setLiveMenuOpen(!liveMenuOpen)}
          style={{ cursor: "pointer" }}
        >
          Live Management {liveMenuOpen ? "▼" : "▶"}
        </div>

        {liveMenuOpen && (
          <div className="sub-menu">
            <NavLink
              to="/live-users"
              className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
            >
              Live Users
            </NavLink>

            <NavLink
              to="/live-ban"
              className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
            >
              Live Ban
            </NavLink>

            <NavLink
              to="/live-ban-list"
              className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
            >
              Live Ban List
            </NavLink>

            <NavLink
              to="/live-ban-history"
              className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
            >
              Live Ban History
            </NavLink>
          </div>
        )}

        

        {/* Device Management Dropdown */}
        <div
          className="menu-title"
          onClick={() => setDeviceMenuOpen(!deviceMenuOpen)}
          style={{ cursor: "pointer" }}
        >
          Device Management {deviceMenuOpen ? "▼" : "▶"}
        </div>

         {deviceMenuOpen && (
          <div className="sub-menu">
            <NavLink
              to="/device-ban"
              className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
            >
              Device Ban
            </NavLink>

            <NavLink
              to="/device-ban-list"
              className={({ isActive }) => (isActive ? "menu-item active" : "menu-item")}
            >
              Device Ban List
            </NavLink>
          </div>
        )}




        {/* Settings Dropdown */}
        <div
          className="menu-title"
          onClick={() => setSettingsMenuOpen(!settingsMenuOpen)}
          style={{ cursor: "pointer" }}
        >
          Settings {settingsMenuOpen ? "▼" : "▶"}
        </div>

        {settingsMenuOpen && (
          <div className="sub-menu">
            <NavLink
              to="/reward-setting"
              className={({ isActive }) =>
                isActive ? "menu-item active" : "menu-item"
              }
            >
              Reward Setting
            </NavLink>

            <NavLink
              to="/commission-setting"
              className={({ isActive }) =>
                isActive ? "menu-item active" : "menu-item"
              }
            >
              Commission Setting
            </NavLink>
          </div>
        )}

        <button
          className="logout-btn"
          onClick={handleLogout}
        >
          🚪 Logout
        </button>
</div>

      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};

function App() {
  const [liveMenuOpen, setLiveMenuOpen] = useState(false);
  const [deviceMenuOpen, setDeviceMenuOpen] = useState(false);
  const [adminMenuOpen, setAdminMenuOpen] = useState(true);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [settingsMenuOpen, setSettingsMenuOpen] = useState(false);
  const [applicationMenuOpen, setApplicationMenuOpen] = useState(false);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          element={
            <ProtectedLayout
              liveMenuOpen={liveMenuOpen}
              setLiveMenuOpen={setLiveMenuOpen}
              deviceMenuOpen={deviceMenuOpen}
              setDeviceMenuOpen={setDeviceMenuOpen}
              adminMenuOpen={adminMenuOpen}
              setAdminMenuOpen={setAdminMenuOpen}
              userMenuOpen={userMenuOpen}
              setUserMenuOpen={setUserMenuOpen}
              settingsMenuOpen={settingsMenuOpen}
              setSettingsMenuOpen={setSettingsMenuOpen}
              applicationMenuOpen={applicationMenuOpen}
              setApplicationMenuOpen={setApplicationMenuOpen}
            />
          }
        >
          <Route path="/" element={<Navigate to="/live-users" replace />} />
          <Route path="/live-users" element={<LiveUsers />} />
          <Route path="/live-ban" element={<LiveBan />} />

          <Route path="/live-ban-list" element={<LiveBanList />} />
          <Route path="/live-ban-history" element={<LiveBanHistory />} />

          <Route path="/device-ban" element={<DeviceBan />} />
          <Route path="/device-ban-list" element={<DeviceBanList />} />

          <Route path="/country-head" element={<CountryHead />} />
          <Route path="/admin-list" element={<AdminList />} />
          <Route path="/bd-admin" element={<BDAdmin />} />
          <Route path="/agency-management" element={<AgencyManagement />} />
          <Route path="/agency-recharge" element={<AgencyRecharge />} />

          <Route path="/commission-setting" element={<CommissionSetting />} />
        <Route path="/user-control" element={<UserControl />} />
        <Route path="/host-rights" element={<HostRights />} />
        <Route path="/host-rewards" element={<HostRewards />} />
        <Route path="/reward-setting" element={<HostRewardSetting />} />
        <Route path="/applications" element={<Applications />} />
         </Route>
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
